
import { useContext, useEffect, useState } from 'react'
import { getAccessToken, PingIdentityContext } from '@rsmus/react-pingidentity'

const INTERNAL_USER_GROUP = 'Internal Users'

const decodeJwtPayload = (token: string): any => {
  const payload = token.split('.')[1]
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    '='
  )

  return JSON.parse(window.atob(padded))
}

const getClaimValues = (claim: string | string[] | undefined): string[] => {
  if (!claim) {
    return []
  }

  return Array.isArray(claim) ? claim : [claim]
}

const hasInternalGroup = (groups: string[]) =>
  groups.some(
    group => group.toLowerCase() === INTERNAL_USER_GROUP.toLowerCase()
  )

export const useHasInternalClaim = () => {
  const { user } = useContext(PingIdentityContext)
  const [authorized, setAuthorized] = useState<boolean | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const authorizeFromAccessToken = async () => {
      setIsLoading(true)

      if (!user) {
        if (!cancelled) {
          setAuthorized(false)
          setIsLoading(false)
        }
        return
      }

      try {
        const accessToken = await getAccessToken()
        const tokenPayload = accessToken ? decodeJwtPayload(accessToken) : null
        const groups = getClaimValues(tokenPayload?.groups)

        if (!cancelled) {
          setAuthorized(hasInternalGroup(groups))
        }
      } catch {
        if (!cancelled) {
          setAuthorized(false)
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false)
        }
      }
    }

    authorizeFromAccessToken()

    return () => {
      cancelled = true
    }
  }, [user])

  return { authorized, isLoading }
}
